import { Ref, ref } from "vue";

import { ContextCommand } from "@/core/modules/layout/interfaces/ContextCommand";

export class KoruTinyBrowserModule<T> {
  public canEdit = true;
  public canView = true;
  public contextCommands: ContextCommand[] = [];
  public documents: Ref<T[]> = ref([]);
  public explicitRequiredModule: string | undefined = undefined;
  public loadingStop = true;
  public path = "";
  public searchFields: string[] = [];
  public sortField = "";
  public sortOrder = 1;
  public suffix = "";

  public onDeleteAction(document: T): Promise<boolean> {
    console.log(document);
    return Promise.resolve(true);
  }

  public onLoadAction(): Promise<void> {
    return Promise.resolve();
  }

  public onMountedAction(): Promise<void> {
    return Promise.resolve();
  }
}
